import Stimulus from "stimulus_init"
import ConfettiController from "controllers/confetti_controller"
import DependentSelectController from "controllers/dependent_select_controller"
import LoadMoreController from "controllers/load_more_controller"
import PreferencesCheckboxController from "controllers/newsletters/preferences_checkbox_controller"

Stimulus.register("confetti", ConfettiController)
Stimulus.register("dependent-select", DependentSelectController)
Stimulus.register("load-more", LoadMoreController)
Stimulus.register("newsletters--preferences-checkbox", PreferencesCheckboxController)
